export default __webpack_public_path__ + "static/itAllAddsUpCard3-335e27799c85abd60781244de137b6a1.png";